import { useRouter } from '#imports';
import { storeToRefs } from 'pinia';
import { captureMessage } from '~/lib/sentry';
import ShopApi from '~/lib/shop-api';
import { openModal } from '~/composables/modal';
import { useCartStore } from '~/stores/cart';
import type { ModalButton } from '@i22/td-longtail-vue-components';

export const showPaymentModal = (
  text = 'Die Bestellung muss noch bezahlt werden.',
  showCancel = true
) => {
  const { cartData, getAnonymousCartData } = storeToRefs(useCartStore());
  const router = useRouter();

  if (!cartData.value) return false;

  captureMessage('Die Bestellung muss noch bezahlt werden', {
    contexts: {
      cart: getAnonymousCartData.value,
    },
    tags: {
      orderKey: cartData.value?.orderKey,
      orderId: cartData.value?.id,
    },
  });

  const buttons: ModalButton[] = [];

  let content = text;
  // In a joint cart we have the special payment pages
  if (cartData.value.jointCart) {
    content += '<br>Klicke "Zur Zahlungsübersicht" um weitere Details zu sehen.';
    buttons.push({
      name: 'Zur Zahlungsübersicht',
      primary: true,
      tag: 'nuxt-link',
      to:
        cartData.value.state === 'brodos_payment_transferred'
          ? '/shop/telekom-bestaetigung'
          : '/shop/telekom-bezahlung-information',
    });
  } else {
    if (showCancel) {
      buttons.push({
        name: 'Abbrechen',
        outline: true,
        click: async (closeModalCB) => {
          closeModalCB();
          await ShopApi.revertOrderToCart();
          router.push('/shop/warenkorb');
        },
      });
    }

    const paymentLink =
      cartData.value.paymentLinkTelekom || cartData.value.paymentLinkBrodos || undefined;
    if (paymentLink) {
      content += '<br>Klicke "Zum Zahlungsanbieter" um die Bestellung zu bezahlen.';
      buttons.push({
        name: 'Zum Zahlungsanbieter',
        primary: true,
        // @ts-ignore
        target: '_self',
        tag: 'a',
        to: paymentLink,
      });
    }

    if (showCancel) {
      content +=
        '<br>Klicke "Abbrechen" um den Zahlungsvorgang zu beenden. Du kannst dann eine andere Zahlungsart wählen.';
    }
  }
  openModal({
    closeOnBackdrop: false,
    heading: 'Zahlung ausstehend',
    content,
    buttons,
  });

  return true;
};
